import axiosFlow from '@/services/axios/axiosFlow'

export default class CanalService {
  static async getTiposDeCanais() {
    return axiosFlow.get('canais/tipos').then(res => res.data.data)
  }

  static async getTiposDeTemplatesWhatsApp() {
    return axiosFlow.get('canais/tipos-templates-whatsapp').then(res => res.data.data)
  }

  static async get(canalTipoId) {
    const params = new URLSearchParams()

    if (canalTipoId) {
      params.append('CanalTipoId', Number(canalTipoId))
    }
    params.append('ItemsPerPage', 10000)

    return axiosFlow.get(`canais?${params}`).then(res => res.data.data.items)
  }

  static async getCanalEmailImapSmtp(canalId) {
    return axiosFlow.get(`canais/${canalId}/email/imap-smtp`).then(res => res.data.data)
  }

  static async getCanalEmailMicrosoft(canalId) {
    return axiosFlow.get(`canais/${canalId}/email/microsoft`).then(res => res.data.data)
  }

  static async getCanalEmailTemplates(canalId) {
    return axiosFlow.get(`canais/${canalId}/email/templates`).then(res => res.data.data)
  }

  static async getCanalEmailBlacklist(canalId) {
    return axiosFlow.get(`canais/${canalId}/email/blacklist`).then(res => res.data.data)
  }

  static async getCanalWhatsApp(canalId) {
    return axiosFlow.get(`canais/${canalId}/whatsapp`).then(res => res.data.data)
  }

  static async getTemplatesWhatsApp(canalId) {
    return axiosFlow.get(`canais/${canalId}/whatsapp/templates`).then(res => res.data.data)
  }

  static async getCanalSMS(canalId) {
    return axiosFlow.get(`canais/${canalId}/sms`).then(res => res.data.data)
  }

  static async getCanalConfigChatBot(canalId) {
    return axiosFlow.get(`canais/${canalId}/bot`).then(res => res.data.data)
  }

  static async getCanalConfigMetaMessenger(canalId) {
    return axiosFlow.get(`canais/${canalId}/meta/messenger`).then(res => res.data.data)
  }

  static async getCanalConfigAutoatendimento(canalId) {
    return axiosFlow.get(`canais/${canalId}/autoatendimento`).then(res => res.data.data)
  }

  static async ativarOuInativarItem(canalId, body) {
    return axiosFlow.put(`canais/${canalId}/ativado`, body)
  }

  static async createCanalAberturaManual(body) {
    return axiosFlow.post('canais/abertura-manual', body)
  }

  static async updateCanalAberturaManual(canalId, body) {
    return axiosFlow.put(`canais/${canalId}/abertura-manual`, body)
  }

  static async createCanalEmail(body) {
    return axiosFlow.post('canais/email', body)
  }

  static async updateCanalEmail(canalId, body) {
    return axiosFlow.put(`canais/${canalId}/email`, body)
  }

  static async criarCanalEmailTemplate(canalId, body) {
    return axiosFlow.post(`canais/${canalId}/email/templates`, body)
  }

  static async atualizarCanalEmailTemplate(canalId, templateId, body) {
    return axiosFlow.put(`canais/${canalId}/email/templates/${templateId}`, body)
  }

  static async ativarOuInativarCanalEmailTemplate(canalId, templateId, body) {
    return axiosFlow.put(`canais/${canalId}/email/templates/${templateId}/ativado`, body)
  }

  static async criarCanalEmailBlacklist(canalId, body) {
    return axiosFlow.post(`canais/${canalId}/email/blacklist`, body)
  }

  static async deletarCanalEmailBlacklist(canalId, body) {
    return axiosFlow.delete(`canais/${canalId}/email/blacklist`, body)
  }

  static async createCanalWhatsApp(body) {
    return axiosFlow.post('canais/whatsapp', body)
  }

  static async updateCanalWhatsApp(canalId, body) {
    return axiosFlow.put(`canais/${canalId}/whatsapp`, body)
  }

  static async createTemplateWhatsApp(canalId, body) {
    return axiosFlow.post(`canais/${canalId}/whatsapp/templates`, body)
  }

  static async updateTemplateWhatsApp(canalId, templateId, body) {
    return axiosFlow.put(`canais/${canalId}/whatsapp/templates/${templateId}`, body)
  }

  static async createCanalSms(body) {
    return axiosFlow.post('canais/sms', body)
  }

  static async updateCanalSms(canalId, body) {
    return axiosFlow.put(`canais/${canalId}/sms`, body)
  }

  static async createCanalAutoatendimento(body) {
    return axiosFlow.post('canais/autoatendimento', body)
  }

  static async updateCanalAutoatendimento(canalId, body) {
    return axiosFlow.put(`canais/${canalId}/autoatendimento`, body)
  }

  static async createCanalChatBot(body) {
    return axiosFlow.post('canais/bots', body)
  }

  static async updateCanalChatBot(canalId, body) {
    return axiosFlow.put(`canais/${canalId}/bots`, body)
  }

  static async createCanalMetaMessenger(body) {
    return axiosFlow.post('canais/meta/messenger', body)
  }

  static async updateCanalMetaMessenger(canalId, body) {
    return axiosFlow.put(`canais/${canalId}/meta/messenger`, body)
  }
}
